import { useState } from "react";
import { Sheet } from "./Sheet";
import { useT, useAmount } from "../../lib/LocaleContext";

export function PumpSheet({
  open,
  onSubmit,
  onClose,
}: {
  open: boolean;
  onSubmit: (oz: number, durationMin?: number) => void;
  onClose: () => void;
}) {
  const t = useT();
  const amount = useAmount();
  // `oz` is stored ounces; `amt` mirrors the field in the active unit.
  const [oz, setOz] = useState(3);
  const [amt, setAmt] = useState(() => String(amount.value(3)));
  const [duration, setDuration] = useState("");

  function onAmt(raw: string) {
    setAmt(raw);
    const n = Number(raw);
    setOz(raw.trim() !== "" && Number.isFinite(n) ? amount.toOz(n) : 0);
  }

  function handleSubmit() {
    const dur = duration ? Number(duration) : undefined;
    onSubmit(oz, dur && dur > 0 ? dur : undefined);
    setOz(3);
    setAmt(String(amount.value(3)));
    setDuration("");
  }

  return (
    <Sheet open={open} onClose={onClose} title={t.pumpSheet.title}>
      <label className="field">
        <span className="field__label">{t.pumpSheet.pumpedLabel(amount.word)}</span>
        <input
          className="field__input"
          type="number"
          inputMode="decimal"
          step={amount.unit === "ml" ? "5" : "0.5"}
          min="0"
          value={amt}
          onChange={(e) => onAmt(e.target.value)}
        />
      </label>
      <label className="field">
        <span className="field__label">{t.pumpSheet.durationLabel}</span>
        <input
          className="field__input"
          type="number"
          step="1"
          min="0"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />
      </label>
      <button
        type="button"
        className="btn btn--primary btn--block"
        style={{ marginTop: "1rem" }}
        disabled={oz <= 0}
        onClick={handleSubmit}
      >
        {t.pumpSheet.logPump}
      </button>
    </Sheet>
  );
}
